export type PrimitiveKind = "rectangle" | "oval" | "line" | "polygon" | "star" | "frame";

export interface RectanglePrimitive {
  kind: "rectangle";
  cornerRadii: [number, number, number, number];
}

export interface OvalPrimitive {
  kind: "oval";
  arcStart?: number;  // degrees, 0 = top (12 o'clock), clockwise; default 0
  arcSweep?: number;  // degrees, 1–360; default 360 (full circle)
  ratio?: number;     // 0–0.99; inner radius ratio (donut hole); default 0
}

export interface LinePrimitive {
  kind: "line";
}

export interface PolygonPrimitive {
  kind: "polygon";
  sides: number;
  curvature?: number; // 0–1; corner rounding; default 0
}

export interface StarPrimitive {
  kind: "star";
  points: number;
  innerRadiusRatio: number;
}

export interface FramePrimitive {
  kind: "frame";
}

export type PrimitiveDefinition =
  | RectanglePrimitive
  | OvalPrimitive
  | LinePrimitive
  | PolygonPrimitive
  | StarPrimitive
  | FramePrimitive;

/** Shared defaults for draft preview and inserted primitives. */
export function defaultPrimitiveDefinition(kind: PrimitiveKind): PrimitiveDefinition {
  switch (kind) {
    case "rectangle":
      return { kind, cornerRadii: [0, 0, 0, 0] };
    case "polygon":
      return { kind, sides: 6 };
    case "star":
      return { kind, points: 5, innerRadiusRatio: 0.48 };
    case "oval":
    case "line":
    case "frame":
      return { kind };
  }
}
